import { ref } from 'vue'
import { useHelpers } from '@/shared/lib'

export const useModel = () => {
  const { generateKey } = useHelpers()
  const list = ref<{ id: string; value: string }[]>([])

  /**
   * Функция добавления элемента списка
   * @param item
   */
  const addListItem = (item: string) => {
    list.value.push({
      id: generateKey(),
      value: item,
    })
  }

  /**
   * Функция удаления элемента списка
   * @param id
   */
  const removeListItem = (id: string) => {
    list.value = list.value.filter((item) => item.id !== id)
  }

  return {
    list,

    addListItem,
    removeListItem,
  }
}
